import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BackendAPI } from '@core/models/backend-api';
import { Customer } from '@core/models/customer.model';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class CustomerService {

	constructor (
		private httpClient: HttpClient
		) { }

	getCustomers(agencyId: string): Observable<Customer[]> {
		if (!agencyId )
			throw "CustomerService.getCustomers(agencyId): agencyId must be specified."

		return this.httpClient.get<Customer[]>(BackendAPI.clients, { params: new HttpParams().set("agencyId", agencyId) });
	}

	getClients(clientsIds: string[]): Observable<Customer[]> {
		if (!clientsIds || clientsIds.length === 0) 
			throw "CustomerService.getClients(clientsIds): clientsIds is empty."

		return this.httpClient.get<Customer[]>(BackendAPI.clients, { params: new HttpParams().set("clientIds", clientsIds.join()) });
	}

	createOrUpdateCustomer(agencyId: String | undefined,customer: Customer | undefined) {
		if (agencyId == undefined )
			throw "CustomerService.createOrUpdateCustomer(agencyId): agencyId must be specified."
		return this.httpClient.post<Customer>(BackendAPI.client + agencyId.valueOf(), customer);
	}
}
